<aside
  class="relative z-40 flex h-screen w-full items-center transition-all duration-300"
>
  <div class="relative z-10 ml-5 flex h-[95vh] w-full min-w-0 flex-col rounded-3xl rounded-tr-[66px] border border-transparent bg-lGray900/80 p-3 shadow-panel light:border-lGray700/70 light:bg-lMenu backdrop-blur-xl transition-all duration-300">

    <header class="relative z-10 flex h-16 shrink-0 items-center justify-between px-4">
      <h1 [ngClass]="shortMode() ? 'w-10 !mt-4 mx-auto' : 'w-28 !mt-5'">
        <span class="sr-only">UniCo</span>
        <img [src]="shortMode() ? 'assets/images/unico-logo-short.svg' : 'assets/images/unico-logo.svg'" alt="" aria-hidden="true">
      </h1>

      <button
        type="button"
        class="absolute top-[4.5rem] -right-9 flex items-center justify-center h-9 w-9 rounded-full text-lBlack bg-lWhite hover:bg-lPrimary hover:text-white transition"
        (click)="toggleShortMode()"
      >
        <l-icon class="text-xl !font-semibold">
          {{ shortMode() ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}
        </l-icon>
      </button>
    </header>

    <hr class="mx-auto my-6 shrink-0 border-lGray700" [ngClass]="shortMode() ? 'w-[80%]' : 'w-[90%]'">

    <nav
      class="relative z-10 -mx-3 mt-4 min-h-0 flex-1 py-4"
      [ngClass]="shortMode() ? 'overflow-visible' : 'overflow-y-auto pr-3'"
    >
      <ol class="m-0 flex list-none flex-col gap-2 p-0">
        <ng-container *ngFor="let menu of menus; let i = index">
          <li class="relative isolate">
            <ng-container *ngIf="!menu.submenus?.length">
              <a
                class="relative flex w-full items-center gap-3 rounded-l-none rounded-r-full py-2 text-left no-underline transition text-lWhite"
                [routerLink]="'/' + menu.link"
                [ngClass]="[
                  i === activatedIndex() ? '' : 'hover:bg-black/20 light:hover:bg-black/[0.06]',
                  shortMode() ? 'justify-center px-0' : 'pl-6 pr-3'
                ]"
              >
                @if (i === activatedIndex()) {
                  <span class="pointer-events-none absolute inset-y-0 left-0 w-2 rounded-r-md bg-gradient-button"></span>
                  <span
                    class="pointer-events-none absolute inset-y-0 left-2 rounded-r-full bg-black/20 light:bg-lPrimary/15"
                    [ngClass]="shortMode() ? 'right-2' : 'right-0'"
                  ></span>
                }

                <div
                  class="relative z-10 flex min-w-0 items-center gap-3"
                  [ngClass]="shortMode() ? 'justify-center' : 'w-full'"
                >
                  <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition">
                    <l-icon
                      class="!text-3xl"
                      [style.font-variation-settings]="i === activatedIndex() ? '\'FILL\' 1' : '\'FILL\' 0'"
                    >
                      {{ menu.icon }}
                    </l-icon>
                  </div>

                  @if (!shortMode()) {
                    <div class="min-w-0 flex-1">
                      <h4 class="text-xl font-semibold">{{ menu.title }}</h4>
                    </div>
                  }
                </div>
              </a>
            </ng-container>

            @if (menu.submenus?.length) {
              <ng-container>
                <div
                  class="relative flex w-full items-center gap-3 rounded-l-none rounded-r-full py-2 text-lWhite transition"
                  [ngClass]="[
                    i === activatedIndex() ? '' : 'hover:bg-black/20 light:hover:bg-black/[0.06]',
                    shortMode() ? 'justify-center px-0' : 'pl-6 pr-3'
                  ]"
                >
                  @if (i === activatedIndex()) {
                    <span class="pointer-events-none absolute inset-y-0 left-0 w-2 rounded-r-md bg-gradient-button"></span>
                    <span
                      class="pointer-events-none absolute inset-y-0 left-2 rounded-r-full bg-black/20 light:bg-lPrimary/15"
                      [ngClass]="shortMode() ? 'right-2' : 'right-0'"
                    ></span>
                  }

                  <a
                    class="relative z-10 flex min-w-0 flex-1 items-center gap-3 no-underline text-lWhite"
                    [routerLink]="'/' + menu.link"
                    [ngClass]="{ 'justify-center': shortMode() }"
                  >
                    <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition">
                      <l-icon
                        class="!text-3xl"
                        [style.font-variation-settings]="pageKey() === menu.key ? '\'FILL\' 1' : '\'FILL\' 0'"
                      >
                        {{ menu.icon }}
                      </l-icon>
                    </div>

                    @if (!shortMode()) {
                      <div class="min-w-0 flex-1">
                        <h4 class="text-xl font-semibold">{{ menu.title }}</h4>
                      </div>
                    }
                  </a>

                  @if (!shortMode()) {
                    <button
                      type="button"
                      class="relative z-10 mr-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-transparent text-lSecondary transition hover:text-lWhite"
                      (click)="toggleMenu(i)"
                      [attr.aria-expanded]="isParentExpanded(menu)"
                      [attr.aria-label]="isParentExpanded(menu) ? 'Recolher submenu' : 'Expandir submenu'"
                    >
                      <l-icon
                        class="inline-block origin-center text-xl"
                        [@chevronRotate]="isParentExpanded(menu) ? 'expanded' : 'collapsed'"
                      >
                        expand_more
                      </l-icon>
                    </button>
                  }
                </div>

                @if (!shortMode() && isParentExpanded(menu)) {
                  <div @submenuExpand class="overflow-hidden">
                    <div class="relative ml-[2.125rem] mt-2.5 pl-9">
                      <span class="absolute bottom-3 left-[1.375rem] top-3 w-0.5 rounded-full bg-lGray700"></span>

                      <ol class="m-0 flex list-none flex-col gap-1 p-0">
                        @for (submenu of menu.submenus; track submenu.link) {
                          <li class="relative">
                            <a
                              class="relative flex items-center gap-2.5 rounded-full py-1.5 pl-3 pr-2.5 text-left no-underline transition"
                              [routerLink]="'/' + submenu.link"
                              [ngClass]="isSubmenuActive(submenu) ? 'bg-lSecondary/10 text-lWhite' : 'text-lSecondary hover:bg-lSecondary/10 hover:text-lWhite'"
                            >
                              <div class="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl">
                                <l-icon
                                  class="!text-2xl"
                                  [style.font-variation-settings]="isSubmenuActive(submenu) ? '\'FILL\' 1' : '\'FILL\' 0'"
                                >
                                  {{ submenu.icon }}
                                </l-icon>
                              </div>

                              <span class="truncate text-base font-medium">{{ submenu.title }}</span>
                            </a>
                          </li>
                        }
                      </ol>
                    </div>
                  </div>
                }
              </ng-container>
            }
          </li>
        </ng-container>
      </ol>
    </nav>

    <hr class="mx-auto my-4 shrink-0 border-lGray700" [ngClass]="shortMode() ? 'w-[80%]' : 'w-[90%]'"/>

    <footer class="relative z-10 shrink-0 p-4">
      @if (shortMode()) {
        <div class="flex flex-col items-center justify-center gap-4">
          <l-avatar
            [name]="me()?.name || 'Usuário'"
            [imageUrl]="me()?.imageUrl"
            sizeClass="h-12 w-12 border border-lWhite text-sm"
          />

          <button
            type="button"
            class="flex h-12 w-12 items-center justify-center rounded-full border-0 bg-gradient-primary text-white transition-all duration-300"
            (click)="toggleTheme()"
            [title]="theme() === ThemeEnum.DARK ? 'Light mode' : 'Dark mode'"
          >
            <l-icon>{{ theme() === ThemeEnum.DARK ? 'light_mode' : 'dark_mode' }}</l-icon>
          </button>
        </div>
      } @else {
        <div class="mb-3 flex items-center gap-3 p-3">
          <l-avatar
            [name]="me()?.name || 'Usuário'"
            [imageUrl]="me()?.imageUrl"
            sizeClass="h-11 w-11 text-sm"
          />

          <div class="min-w-0 flex-1">
            <span class="block truncate text-sm font-semibold text-lWhite">{{ me()?.name ?? 'Nome completo' }}</span>
            <small class="block truncate text-xs text-lSecondary">{{ me()?.email ?? 'example@email.com' }}</small>
          </div>

          <button
            type="button"
            class="h-9 w-9 bg-transparent text-lSecondary hover:text-lWhite transition"
            (click)="logout()"
            title="Logout"
          >
            <l-icon class="text-xl">logout</l-icon>
          </button>
        </div>

        <div class="relative w-full rounded-[85px] bg-black/20 light:bg-black/[0.06] p-2">
          <span
            class="pointer-events-none absolute inset-y-2 left-2 w-[calc(50%-0.5rem)] rounded-full bg-gradient-primary transition-transform duration-300 ease-in-out"
            [ngClass]="theme() === ThemeEnum.DARK ? 'translate-x-full' : 'translate-x-0'"
          ></span>

          <div class="relative z-10 flex w-full items-center">
            <button
              type="button"
              class="flex flex-1 h-9 items-center justify-center rounded-full border-0 bg-transparent transition-colors duration-300"
              [ngClass]="theme() !== ThemeEnum.DARK ? 'text-white' : 'text-lSecondary hover:text-lWhite'"
              (click)="setTheme(ThemeEnum.LIGHT)"
              title="Light mode"
            >
              <l-icon>light_mode</l-icon>
            </button>
            <button
              type="button"
              class="flex flex-1 h-9 items-center justify-center rounded-full border-0 bg-transparent transition-colors duration-300"
              [ngClass]="theme() === ThemeEnum.DARK ? 'text-white' : 'text-lSecondary hover:text-lWhite'"
              (click)="setTheme(ThemeEnum.DARK)"
              title="Dark mode"
            >
              <l-icon>dark_mode</l-icon>
            </button>
          </div>
        </div>
      }

      <p class="m-0 mt-3 select-none text-center text-[10px] leading-none text-lSecondary" title="Versão do sistema">
        {{ appVersion }}
      </p>
    </footer>
  </div>
</aside>
